import data from './mock1_weekly_stats.json';
export const WEEKLY_STATS = data;
